import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center h-screen" }
const _hoisted_2 = { class: "w-[350px] h-[650px] rounded-md bg-black px-2" }
const _hoisted_3 = { class: "flex justify-between bg-black px-2 py-1" }
const _hoisted_4 = { class: "text-white text-sm" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex space-x-2 items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined text-sm text-white" }, " network_cell "),
  /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined text-white text-sm" }, " network_wifi "),
  /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined text-white" }, " battery_full_alt ")
], -1)
const _hoisted_6 = { class: "relative top-32 pr-4 font-sans h-24 mt-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-white text-5xl text-right result font-bold" }, null, -1)
const _hoisted_8 = { class: "mt-28 rounded-t-md p-4 bg-[#2a2d37] font-sans font-bold flex flex-col space-y-4" }
const _hoisted_9 = { class: "flex justify-between" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-delete-left" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "flex justify-between" }
const _hoisted_13 = { class: "flex justify-between" }
const _hoisted_14 = { class: "flex justify-between" }
const _hoisted_15 = { class: "flex justify-between" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-repeat" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.time), 1),
        _hoisted_5
      ]),
      _createElementVNode("section", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userData) = $event)),
          class: "text-white text-xl text-right bg-black relative left-16",
          disabled: ""
        }, null, 512), [
          [_vModelText, _ctx.userData]
        ]),
        _hoisted_7
      ]),
      _createElementVNode("section", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-[#40b1a1] text-xl",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "AC"),
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-[#40b1a1] text-xl",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, _hoisted_11),
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-[#9dcec7] text-xl",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "%"),
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-[#e25089] text-xl",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "/")
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-white text-xl",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "7"),
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-white text-xl",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "8"),
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-white text-xl",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "9"),
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-[#e25089] text-xl",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "x")
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-white text-xl",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "4"),
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-white text-xl",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "5"),
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-white text-xl",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "6"),
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-[#e25089] text-xl",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "-")
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-white text-xl",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "1"),
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-white text-xl",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "2"),
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-white text-xl",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "3"),
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-[#e25089] text-xl",
            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "+")
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-white text-xl",
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, _hoisted_17),
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-white text-xl",
            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "0"),
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-white text-xl",
            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "."),
          _createElementVNode("button", {
            class: "w-14 h-14 rounded-md bg-black text-[#e25089] text-xl",
            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.getValue && _ctx.getValue(...args)))
          }, "=")
        ])
      ])
    ])
  ]))
}